import { ROUTE_PERMISSIONS } from '@shared/permissions';
import { lazyWithReload } from '@shared/react/lazyWithReload';
import { PermissionGuard, ValidUuidGuard } from '@shared/router';
import { Route } from 'react-router-dom';

import { disputeCreateRoute, disputeDeclineRoute, disputeDetailRoute, disputePath } from './urls';

const DisputeView = lazyWithReload(() =>
  import('./pages/Dispute').then((m) => ({ default: m.DisputeView }))
);
const DisputeDetailsView = lazyWithReload(() =>
  import('./pages/DisputeDetails').then((m) => ({ default: m.DisputeDetailsView }))
);
const DisputeDeclineView = lazyWithReload(() =>
  import('./pages/DisputeDecline').then((m) => ({ default: m.DisputeDeclineView }))
);
const DisputeCreate = lazyWithReload(() =>
  import('./pages/DisputeCreate').then((m) => ({ default: m.DisputeCreate }))
);

export const DisputeRoutes = (
  <>
    <Route
      path={disputePath}
      element={
        <PermissionGuard requiredPermissions={ROUTE_PERMISSIONS.disputes}>
          <DisputeView />
        </PermissionGuard>
      }
    />
    <Route
      path={disputeCreateRoute}
      element={
        <PermissionGuard requiredPermissions={ROUTE_PERMISSIONS.disputes}>
          <DisputeCreate />
        </PermissionGuard>
      }
    />
    <Route
      path={disputeDetailRoute}
      element={
        <PermissionGuard requiredPermissions={ROUTE_PERMISSIONS.disputes}>
          <ValidUuidGuard paramName="disputeId">
            <DisputeDetailsView />
          </ValidUuidGuard>
        </PermissionGuard>
      }
    />
    <Route
      path={disputeDeclineRoute}
      element={
        <PermissionGuard requiredPermissions={ROUTE_PERMISSIONS.disputes}>
          <ValidUuidGuard paramName="disputeId">
            <DisputeDeclineView />
          </ValidUuidGuard>
        </PermissionGuard>
      }
    />
  </>
);
